import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VOP_REQUIEST_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { VopRequestComponent } from './vop-request/vop-request.component';

const routes: Routes = [
  {
    path: VOP_REQUIEST_ROUTE,
    component: VopRequestComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VopRequestRoutingModule {}
